import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";
import {css,cx} from "emotion";
import {ToastService} from "shared/utilities/services/ToastService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";

library.add(faSpinner);

export class FontUploader extends DynamicDialog<FontUploaderProps, FontUploaderState> {
    static defaultProps: Partial<FontUploaderProps> = {};
    private fileUploaderNode:HTMLInputElement;

    constructor(props: FontUploaderProps) {
        super(props);
        this.state = {
            IsOpen: true,
            IsDragging:false,
            IsUploading:false,
            FileToUpload:''
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:"File Uploader",
            CancelTitle:'Close'
        };
    }

    SubRenderer(): ReactNode {
        return (
            <div onDragStart={()=>alert('a')} style={{textAlign:'center'}}>
                <input onChange={e=>this.OnDrop((this.fileUploaderNode as any).files)} accept={'.ttf'} type={'file'} ref={e=>this.fileUploaderNode=e} style={{display:'none',margin:'auto'}}/>

                {this.state.IsUploading ?
                    <div>
                        <h3><FontAwesomeIcon icon={"spinner"} spin={true}/> Uploading file <span style={{color:'red'}}>{this.state.FileToUpload}</span></h3>
                    </div> :
                    <div onClick={() => this.fileUploaderNode.click()} onDragOver={e => e.preventDefault()}
                         onDrop={e => {
                             e.preventDefault();
                             this.OnDrop(e.dataTransfer.files)
                         }} onDragEnter={(e) => this.OnDragEnter(e)} onDragLeave={(e) => this.OnDragLeave()}
                         className={css`
                  transition: border-color 200ms ease-in-out;
                  &:hover{border-color:red !important;}
                    `} style={{cursor: 'pointer', width: 150, height: 150, border: '1px solid #dfdfdf', margin: 'auto', display: 'flex', alignItems: 'center', fontSize: 16, padding: 10, borderColor: this.state.IsDragging ? 'red' : '#dfdfdf'}}>

                        <p style={{fontSize: 16}}>Drag or click here to upload a font file (*.ttf) here</p>
                    </div>
                }
            </div>

        );
    }


    private OnDragEnter(e: React.DragEvent<HTMLDivElement>) {
        e.preventDefault();
        this.setState({IsDragging:true});
    }

    private OnDragLeave() {
        this.setState({IsDragging:false});
    }

    private async OnDrop(files: FileList) {
        if(files.length>1) {
            ToastService.SendErrorMessage('Please upload one file at a time');
            return;
        }

        if(!files[0].name.toLowerCase().endsWith('.ttf'))
        {
            ToastService.SendErrorMessage("Only .ttf files can be uploaded");
            return;
        }


        this.setState({IsUploading:true,IsDragging:false,FileToUpload:files[0].name.substring(0,files[0].name.length)});
        let result=await WpAjaxPost.Post('upload_font',{},{Nonce:rednaoVar.PDFUtilsNonce},{Font:files[0]});
        this.setState({IsUploading:false});
        this.fileUploaderNode.value='';

        if(result!=null) {
            rednaoVar.AvailableFonts.push(result);
            this.SendResult(result);

            let css:HTMLStyleElement=document.createElement('style');
            css.type='text/css';
            css.appendChild(document.createTextNode(`@font-face{font-family:${result}; src:url('${rednaoVar.FontURL+result}');}`));
            document.body.appendChild(css);

            ToastService.SendSuccess("Font " + result + ' uploaded successfully');
        }

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FontUploaderProps extends DynamicDialogProps {

}

interface FontUploaderState extends DynamicDialogState {
    IsDragging:boolean,
    IsUploading:boolean
    FileToUpload:string;
}

//#endregion "My Region"